
export const PRODUCTS_PAGINATE_DATA_CHANGE = 'PRODUCTS_PAGINATE_DATA_CHANGE';

export const productsPaginateDataChanged = (paginateData) => (dispatch) => {
    dispatch({
        type: PRODUCTS_PAGINATE_DATA_CHANGE,
        payload: paginateData
    });
} 


// WEBPACK FOOTER //
// ./src/redux/actions/product/paginate-data.js